import React from 'react';
import moment from 'moment';
import { locales } from 'utils';
import CustomScrollbars from '../CustomScrollbars';
import Translated from '../Translated';
import { StyledButton } from './Locale.styled';

const Locale = ({ switchLocale }) => {
    function handleSwitch(locale) {
        switchLocale(locale);
        moment.locale(locale);
    }

    return (
        <CustomScrollbars className="gx-popover-lang-scroll">
            <ul className="gx-sub-popover">
                { locales.map(locale => (
                    <li key={locale}>
                        <StyledButton type="button" className="gx-media gx-pointer" onClick={() => handleSwitch(locale)}>
                            <span className="gx-language-name"><Translated id={`locale.${locale}`} /></span>
                        </StyledButton>
                    </li>
                )) }
            </ul>
        </CustomScrollbars>
    );
};

export default Locale;
